import { useEffect } from "react";
import { Navigation } from "../cmps/homepage/navigation";
import { FooterSection } from "../cmps/homepage/footer-section";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";

export default function ContactPage() {
  useEffect(() => {
    document.title = "Contact | MANAGE ME";
  }, []);

  return (
    <div className="homepage-root">
      <main className="relative min-h-screen overflow-x-hidden">
        <Navigation />

        <section className="relative py-24 md:py-32 px-4">
          <div className="max-w-4xl mx-auto">
            <div className="mb-8">
              <span className="inline-flex items-center gap-3 text-sm font-mono text-foreground/60 mb-8">
                <span className="w-8 h-px bg-foreground/30" />
                Contact
              </span>
            </div>

            <h1 className="text-6xl md:text-7xl lg:text-8xl font-display tracking-tight leading-[0.9] mb-8">
              Talk to a
              <br />
              <span className="text-foreground/40">supervisor.</span>
            </h1>
          </div>
        </section>

        <section className="relative py-24 px-4 border-t border-foreground/10">
          <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16">
            <div>
              <h2 className="text-3xl md:text-4xl font-display mb-12">Get in touch</h2>

              <div className="space-y-12">
                <div>
                  <h3 className="text-sm font-mono text-foreground/60 uppercase tracking-wider mb-2">
                    Email
                  </h3>
                  <a
                    href="mailto:hello@manageme.app"
                    className="text-2xl font-display text-foreground hover:text-foreground/70 transition-colors"
                  >
                    hello@manageme.app
                  </a>
                </div>

                <div>
                  <h3 className="text-sm font-mono text-foreground/60 uppercase tracking-wider mb-2">
                    Phone
                  </h3>
                  <a
                    href="tel:+15550104242"
                    className="text-2xl font-display text-foreground hover:text-foreground/70 transition-colors"
                  >
                    +1 (555) 010-4242
                  </a>
                </div>

                <div>
                  <h3 className="text-sm font-mono text-foreground/60 uppercase tracking-wider mb-2">
                    Headquarters
                  </h3>
                  <p className="text-lg text-foreground/70">
                    12 Marina Boulevard, Suite 200
                  </p>
                </div>
              </div>
            </div>

            <div>
              <form className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-foreground mb-2">
                    Full name
                  </label>
                  <Input
                    id="name"
                    type="text"
                    placeholder="Your name"
                    className="w-full h-12 px-4 border border-foreground/20 rounded-lg focus:border-foreground focus:outline-none transition-colors"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-foreground mb-2">
                    Work email
                  </label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="you@company.com"
                    className="w-full h-12 px-4 border border-foreground/20 rounded-lg focus:border-foreground focus:outline-none transition-colors"
                  />
                </div>

                <div>
                  <label htmlFor="company" className="block text-sm font-medium text-foreground mb-2">
                    Company
                  </label>
                  <Input
                    id="company"
                    type="text"
                    placeholder="Your company"
                    className="w-full h-12 px-4 border border-foreground/20 rounded-lg focus:border-foreground focus:outline-none transition-colors"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-foreground mb-2">
                    Message
                  </label>
                  <Textarea
                    id="message"
                    placeholder="Tell us about your project..."
                    rows={5}
                    className="w-full px-4 py-3 border border-foreground/20 rounded-lg focus:border-foreground focus:outline-none transition-colors resize-none"
                  />
                </div>

                <Button
                  type="submit"
                  className="w-full bg-foreground hover:bg-foreground/90 text-background h-12 rounded-lg text-base font-medium"
                >
                  Send message
                </Button>
              </form>
            </div>
          </div>
        </section>

        <FooterSection />
      </main>
    </div>
  );
}
